import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Text } from 'onefaceui-react-components';
import { ShortcutsListContainer } from './styles';

function ShortcutsList({
  closeMenu, floatMenuOptions, menus, data
}) {
  if (!floatMenuOptions.isOpen) return null;

  return (
    <ShortcutsListContainer
      style={{ left: `${floatMenuOptions.right + 8}px`, top: `${floatMenuOptions.top}px` }}
      data-testid="shortcuts-list"
      className={floatMenuOptions.isVisible ? 'placement-top' : 'placement-bottom'}
    >
      {menus.map(({
        name, iconClass, onClick, type
      }) => (
        <button
          type="button"
          key={type}
          onClick={() => {
            onClick(data);
            closeMenu();
          }}
          data-testid={`shortcut-${type}`}
        >
          <span className={iconClass} />
          <Text size="xs" overflow="ellipsis">{name}</Text>
        </button>
      ))}
    </ShortcutsListContainer>
  );
}

ShortcutsList.propTypes = {
  menus: PropTypes.array.isRequired,
  closeMenu: PropTypes.func.isRequired,
  floatMenuOptions: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired
};

export default memo(ShortcutsList);
